export const getters = {
	isTrackingVerified(state) {
		return Boolean(state.counters?.totalEvents);
	}
};
